<template>
  <app-loading />
  <app-flash-message />
  <NuxtLayout>
    <v-app>
      <nuxt-page />
    </v-app>
  </NuxtLayout>
</template>
